var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,191c0,0.6,0,129.3,0,129.9c0.5,58.4,48.2,105.7,106.6,105.7h298.7c58.8,0,106.7-47.9,106.7-106.7V192 c0-58.8-47.9-106.7-106.7-106.7H106.7C48.2,85.3,0.6,132.7,0,191z M405.3,128c35.3,0,64,28.7,64,64v128c0,35.3-28.7,64-64,64H106.7 c-31,0-56.9-22.1-62.8-51.4l29.6-14.8c7.2-3.6,11.8-11,11.8-19.1v-85.3c0-8.1-4.6-15.5-11.8-19.1l-29.6-14.8 c5.8-29.3,31.8-51.4,62.8-51.4H405.3L405.3,128z M426.7,234.6v42.7c0,11.8-9.6,21.3-21.3,21.3l0,0c-11.8,0-21.3-9.6-21.3-21.3v-42.7 c0-11.8,9.6-21.3,21.3-21.3l0,0C417.1,213.3,426.7,222.9,426.7,234.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.aa3c00810b1ae36511e7f66aae506204.svg";
export { ForwardRef as ReactComponent };